module.exports = __webpack_public_path__ + "static/media/emptyQuote.605b2873.svg";